import React from 'react';

import Button from "../../elements/buttons/Button";   


const Plan = ({plan, precio, imagenDispositivos, dispositivos, imagenUbicaciones, ubicaciones, linkPrueba, linkDetalles, className, classNameLinkPrueba, copyLinkPrueba, classNameLinkDetalles, copyLinkDetalles}) =>(
    <>
        <article className={`plan ${className}`}>
            <small>{plan} <span className="mas-elegido">Más elegido</span></small>
            <h2>BS {precio} <span>/X MES</span></h2>
            <ul>
                <li>
                    <figure><img src={imagenDispositivos} /></figure> {dispositivos} dispositivos
                </li>
                <li>
                    <figure><img src={imagenUbicaciones} /></figure> {ubicaciones} ubicaciones
                </li>
            </ul>
            <Button link={linkPrueba} className={classNameLinkPrueba} copy={copyLinkPrueba} />
            <Button link={linkDetalles} className={classNameLinkDetalles} copy={copyLinkDetalles} />
        </article>
    </>
)

export default Plan;